import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
import './registration-form-submit.scss';

@Component({
  template: `
<div class="button-center">
  <div class="button-container">
    <spinner class="absolute" v-if="loading"></spinner>
    <button :disabled="disabled || loading" class="button" type="submit"><slot></slot></button>
  </div>
</div>
`
})
export class RegistrationFormSubmitComponent extends Vue {
  @Prop
  buttonLabel: string;

  @Prop
  loading: boolean;

  @Prop
  disabled: boolean;
}

Vue.component('registration-form-submit', RegistrationFormSubmitComponent);



// WEBPACK FOOTER //
// ./src/components/registration-form-submit/registration-form-submit.ts